/**
 * GitLab Authentication Service
 * Handles authentication flow for GitLab integration
 * Connects the account through provider-token-service
 * All authentication goes through BFF
 */

import providerLinkService from './ProviderLinkService';
import { devLog } from '../utils/devLog';

class GitLabAuthService {
  /**
   * Check whether the user has connected this provider
   * @returns {Promise<boolean>}
   */
  async isAuthenticated() {
    try {
      const status = await providerLinkService.checkLinkStatus('gitlab');
      return status.linked;
    } catch (error) {
      console.error('❌ GitLab authentication check error:', error);
      return false;
    }
  }

  /**
   * Disconnect the provider and clear local credentials
   * @returns {Promise<void>}
   */
  async logout() {
    try {
      await providerLinkService.unlinkProvider('gitlab');
      devLog('✅ GitLab logout successful');
    } catch (error) {
      console.error('❌ GitLab logout error:', error);
      throw error;
    }
  }
}

const GitLabAuth = new GitLabAuthService();
export default GitLabAuth;
